import React from 'react';
import { restaurantInfo, features } from '../data/mock';
import { Award, ShieldCheck, History, Truck } from 'lucide-react';

const iconMap = {
  halal: ShieldCheck,
  quality: Award,
  tradition: History,
  delivery: Truck
};

const AboutSection = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-[#fffef2]">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <p className="text-[#722F37] text-sm font-medium tracking-widest uppercase mb-4">
                Hikayemiz
              </p>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-[#333333] mb-6">
                1990'dan Günümüze<br />
                <span className="text-[#722F37]">Gelenek ve Lezzet</span>
              </h2>
            </div>

            <div className="space-y-4 text-[#666666] leading-relaxed">
              <p>
                1990 yılında küçük bir dükkân olarak yola çıktık. 
                Amacımız sadece döner satmak değil, gerçek Anadolu lezzetini 
                İstanbul'a taşımaktı.
              </p>
              <p>
                35 yıldır değişmeyen tariflerimiz, %100 helal kesim etlerimiz ve 
                hijyen standartlarına titizlikle bağlılığımızla sizlere hizmet veriyoruz.
              </p>
              <p>
                Her lokmasında güven, her tabakta gelenek. Kosovalı Döner ailesi 
                olarak sizleri ağırlamaktan mutluluk duyuyoruz.
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-2 gap-6 pt-8">
              {features.map((feature, index) => {
                const IconComponent = iconMap[feature.icon];
                return (
                  <div key={index} className="space-y-3">
                    <div className="w-12 h-12 bg-[#722F37]/10 flex items-center justify-center">
                      <IconComponent className="w-6 h-6 text-[#722F37]" />
                    </div>
                    <h3 className="font-semibold text-[#333333]">{feature.title}</h3>
                    <p className="text-sm text-[#666666]">{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <img
              src={restaurantInfo.storeImage}
              alt="Kosovalı Döner Mağazası"
              className="w-full h-[500px] lg:h-[600px] object-cover"
            />
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 bg-[#f6f5e8] p-8 hidden lg:block">
              <p className="font-display text-5xl text-[#722F37] font-bold">35+</p>
              <p className="text-[#666666] text-sm mt-1">Yıllık Tecrübe</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;